import React, { Component } from 'react';

require('./botDetailsPage.css');
require('../quill.css');


var firebase = require('firebase');
var db = firebase.firestore(), Quill = require('quill'), editor;
//Secondary Storage Bucket for the Apps
//var fileStorage = firebase.app().storage("gs://tinqerappsfbbucket/");
//var secst = firebase.storage;
//Storage reference 
//var storageRef = fileStorage.ref()
var appInfoRefer = {};

//Toolbar options Quill
/*var toolbarOptions = [
    ['bold', 'italic', 'underline'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'align': [] }],
    ['image'],
    ['video']
]; */

class BotDetailPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dataRecieved: false,
            appInfo: {},
            errMessage: ""
        };
    }

    componentWillMount() {
        var appName = this.props.match.params.botName;
        var appInfoPath = db.collection('applications').doc(appName), referThis = this;

        //Get all the info
        appInfoPath.get().then(function (snapshot) {
            appInfoRefer.appName = snapshot.data().appName;
            appInfoRefer.appType = snapshot.data().appType;
            appInfoRefer.dbPath = snapshot.data().dbPath;
            appInfoRefer.filesPath = snapshot.data().filesPath;
            appInfoRefer.linkInput = snapshot.data().linkInput;
            appInfoRefer.userEmail = snapshot.data().userEmail;
        }).catch(err => {
            //There was an error getting data
            referThis.setState({
                dataRecieved: false,
                errMessage: err.code
            });
        }).then(() => {
            //Initial Data successfully received....


            //Get the description from User's page. 
            var userAppInfoPath = db.collection('users').doc(appInfoRefer.userEmail).collection('applications').doc(appName);

            userAppInfoPath.get().then(function (secSnapshot) {
                appInfoRefer.description = JSON.parse(secSnapshot.data().description);
            }).catch(err => {
                //There was an error getting data
                referThis.setState({
                    dataRecieved: false,
                    errMessage: err.code
                });
                document.getElementById('errorMessage').innerText = 'There was an error getting data, please try again later: ' + err.code;
            }).then(() => {
                referThis.setState({
                    dataRecieved: true,
                    appInfo: appInfoRefer
                });

                //Initialize Quill
                var container = document.getElementById('editor');
                editor = new Quill(container, {
                    readOnly: 'true',
                    theme: 'snow',
                    modules: {
                        toolbar: false
                    }
                });
                //Set the contents 
                editor.setContents(appInfoRefer.description);
            });
        });
    }

    demoBot = () => {
        //Demo the application based on type
        var appType = appInfoRefer.appType, displaying = false;
        var demoContainer = document.getElementById('demoContainer');

        if (displaying) {
            demoContainer.style.display = 'none';
            displaying = false;
        } else {
            console.log("Demo is not currently showing, so switching to display mode");
            console.log("App Type: " + appType);
            demoContainer.style.display = 'block';
            displaying = true;
            switch (appType) {
                case "Chatbot Solution":
                    //Since it is a chatbot, get the URL
                    console.log("Including link");
                    console.log("Including link: " + appInfoRefer.linkInput);
                    var demoIframe = document.getElementById('demoIframe');
                    //var demoDiv = document.getElementById('demoDiv');
                    demoIframe.setAttribute('src', appInfoRefer.linkInput);
                    break;
                default:
                    console.log("Default case");
                    break;
            }
        }

    }
    render() {
        while (!this.state.dataRecieved) {
            return (
                <div className="loadingDiv text-center">
                    <br />
                    <h3><i className="fab fa-pied-piper-alt" id='spinner' ></i></h3>
                    <br />
                </div>
            );
        }
        return (
            <div>
                <div className="container" id="errorMessage">
                    <br />
                    <h3 className="text-center" id='bot_name'>{this.state.appInfo.appName}</h3>
                    <h6 className='text-center'>{this.state.appInfo.userEmail} | <span className="badge badge-primary">{this.state.appInfo.appType}</span>
                    </h6>
                    <hr style={{ backgroundColor: 'blue' }} />
                    <h5>Description: </h5>
                    <div className="editPlace">
                        <div id="editor">
                        </div>
                    </div>
                    <br />
                    <hr style={{ backgroundColor: 'blue', width: '300px' }} />
                    <br />
                    <button type='button' className="btn" id="bot_download_button" onClick={() => this.downloadBot()}>
                        Download
                    </button>
                    <button type='button' className="btn" id="bot_demo_button" onClick={() => this.demoBot()}>
                        Show Demo
                    </button>
                    <br />
                    <br />
                    <div id="demoContainer">
                        <h3 className='text-center'>Demo: </h3>
                        <div className="embed-responsive" id="demoDiv" style={{ display: appInfoRefer.appType === "Chatbot Solution" ? 'block' : 'none' }}>
                            <iframe className="embed-responsive-item" id='demoIframe'
                                src={appInfoRefer.appType === "Chatbot Solution" ? appInfoRefer.linkInput : ''}
                            ></iframe>
                        </div>
                    </div>
                    <br />
                    <br />
                    <section id="package_breakdown">
                        <div className="card packagesCard">
                            <h3 className="card-header text-center" style={{ background: 'transparent' }}>Available Packages: </h3>
                            <div className="card-block">

                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default BotDetailPage;


// WEBPACK FOOTER //
// ./src/BotCatalog/BotDetailPage.js